import { useReducer } from 'react'

import { SORT_OPTIONS } from '@utils/constants'

const initialState = {
  filters: {
    searchText: [],
    countries: [],
    categories: [],
    fcpIds: [],
    startDate: '',
    endDate: ''
  },
  sortBy: SORT_OPTIONS.Newest,
  showFilters: false
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'RESET_FILTERS':
      return initialState
    case 'SET_FILTER':
      return { ...state, filters: { ...state.filters, ...action.filter } }
    case 'SET_SORTBY':
      return { ...state, ...action.sortBy }
    case 'SET_SHOW_FILTERS':
      return { ...state, showFilters: !state.showFilters }
  }
}

const useFilters = () => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return { state, dispatch }
}

export default useFilters
